var _ = require('lodash');

class AuthenticationService {


    static clearListCookies() {
        //document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'JESESSIONID=; Max-Age=0;'
        // document.cookie="JSESSIONID=123;Path=/managerconsole;"
        // window.location = ""; // TO REFRESH THE PAGE
    }
    static clearLocalstorage() {
        this.setToken(null);
        this.setEmail(null);
        this.setUserId(null);
        this.setName(null);
        this.setMobileNumber(null);
        this.setUsername(null);
        //localStorage.clear();
        this.clearListCookies();
    }

    static getToken() { return localStorage.getItem('app:auth:token'); }

    static setToken(token) {

        if (_.isNull(token)) {
            localStorage.removeItem('app:auth:token');
        } else {
            localStorage.setItem('app:auth:token', token);
        }

    }

    static getPlatformFee() { return localStorage.getItem('app:platform:fee'); }

    static setPlatformFee(fee) {
        if (_.isNull(fee)) {
            localStorage.removeItem('app:platform:fee');
        } else {
            localStorage.setItem('app:platform:fee', fee);
        }
    }


    static getRef() { return localStorage.getItem('app:transaction:ref'); }

    static setRef(ref) {

        if (_.isNull(ref)) {
            localStorage.removeItem('app:transaction:ref');
        } else {
            localStorage.setItem('app:transaction:ref', ref);
        }

    }


    static getUserId() { return localStorage.getItem('app:auth:userId'); }

    static setUserId(userId) {

        if (_.isNull(userId)) {
            localStorage.removeItem('app:auth:userId');
        } else {
            localStorage.setItem('app:auth:userId', userId);
        }

    }


    static getEmail() { return localStorage.getItem('app:auth:email'); }

    static setEmail(email) {

        if (_.isNull(email)) {
            localStorage.removeItem('app:auth:email');
        } else {
            localStorage.setItem('app:auth:email', email);
        }

    }




    static getName() { return localStorage.getItem('app:auth:name'); }

    static setName(name) {
        if (_.isNull(name)) {
            localStorage.removeItem('app:auth:name');
        } else {
            localStorage.setItem('app:auth:name', name);
        }
    }



    static getMobileNumber() { return localStorage.getItem('app:auth:mobileNumber'); }

    static setMobileNumber(mobileNumber) {

        if (_.isNull(mobileNumber)) {
            localStorage.removeItem('app:auth:mobileNumber');
        } else {
            localStorage.setItem('app:auth:mobileNumber', mobileNumber);
        }

    }

    static getChannel() { return localStorage.getItem('app:auth:channel'); }

    static setChannel(channel) {

        if (_.isNull(channel)) {
            localStorage.removeItem('app:auth:channel');
        } else {
            localStorage.setItem('app:auth:channel', channel);
        }

    }


    static getFcmToken() { return localStorage.getItem('app:auth:fcm:token'); }

    static setFcmToken(token) {

        if (_.isNull(token)) {
            localStorage.removeItem('app:auth:fcm:token');
        } else {
            localStorage.setItem('app:auth:fcm:token', token);
        }

    }

    static getUsername() { return localStorage.getItem('app:auth:username'); }

    static setUsername(username) {

        if (_.isNull(username)) {
            localStorage.removeItem('app:auth:username');
        } else {
            localStorage.setItem('app:auth:username', username);
        }

    }

    static getImage() { return localStorage.getItem('app:auth:image'); }

    static setImage(image) {

        if (_.isNull(image)) {
            localStorage.removeItem('app:auth:image');
        } else {
            localStorage.setItem('app:auth:image', image);
        }

    }

    static getReferral() { return localStorage.getItem('app:auth:referral'); }

    static setReferral(referral) {

        if (_.isNull(referral)) {
            localStorage.removeItem('app:auth:referral');
        } else {
            localStorage.setItem('app:auth:referral', referral);
        }

    }

}

export default AuthenticationService;